// url urbanky
export const urbanky = 'https://urbanky.com.br/';

// devices
export const appleHref = 'https://apps.apple.com/br/app/urbanky/id1614704388';
export const androidHref = 'https://play.google.com/store/apps/details?id=br.com.urbanky.app';